import { useState, useEffect, useRef } from 'react';
import OneSignal from 'react-onesignal';
import useScrollPosition from '@react-hook/window-scroll';
import usePassiveLayoutEffect from '@react-hook/passive-layout-effect';
import { useWindowSize } from '@Components/Utilities/WindowSize';

const OneSignalButton = (props) => {

    const windowSize = useWindowSize();
    const scrollY = useScrollPosition();
    const originalRightRef = useRef(null);
    const originalBottomRef = useRef(null);
    const scrollToTopRef = useRef(null);

    const [initialized, setInitialized] = useState(false);
    useEffect(function oneSignalInit() {
        OneSignal.init({ appId: props.siteSetting }).then(() => {
            setInitialized(true);
            OneSignal.setDefaultNotificationUrl(props.siteURL);

            OneSignal.on("subscriptionChange", function (isSubscribed) {
                if (isSubscribed) {
                    OneSignal.sendTags({
                        InternalContactCRMID: props.internalContactCRMID,
                        CentralUserAuthID: props.centralUserAuthID
                    });
                }
            });
        });
    }, []);

    usePassiveLayoutEffect(function checkForOneSignal() {
        let oneSignalBellLauncher = document.getElementById('onesignal-bell-launcher');
        if (oneSignalBellLauncher) {
            scrollToTopRef.current = document.getElementsByClassName('scrollToTop')[0];
            let hasListingControlBar = document.getElementsByClassName('mobile-listing-control-bar').length > 0;
            let hasMobileOptionBar = document.getElementsByClassName('mobile-option-bar').length > 0;
            let hasDetailsContactBar = document.getElementsByClassName('detail-contact-bar').length > 0;
            let hasIntercom = document.getElementsByClassName('intercom-launcher').length > 0;

            if (originalRightRef.current) {
                originalRightRef.current = oneSignalBellLauncher.style.right
            }
            if (originalBottomRef.current) {
                originalBottomRef.current = oneSignalBellLauncher.style.bottom
            }

            oneSignalBellLauncher.style.right = originalRightRef.current;
            oneSignalBellLauncher.style.bottom = originalBottomRef.current;

            // Set style if intercom button is present or if "Scroll To Top" button is on the right of the screen
            if (hasIntercom || (scrollToTopRef.current && window.getComputedStyle(scrollToTopRef.current).right === '25px')) {
                oneSignalBellLauncher.style.right = '85px';
            }

            if (hasMobileOptionBar || hasDetailsContactBar) {
                oneSignalBellLauncher.style.bottom = '75px';
            }

            if (hasListingControlBar && windowSize.width < 775) {
                const listingControlBar = document.getElementsByClassName('mobile-listing-control-bar')[0].getBoundingClientRect();

                if (listingControlBar.height > 60) {
                    oneSignalBellLauncher.style.bottom = '89px';
                }
                else {
                    oneSignalBellLauncher.style.bottom = '56px';
                }

                const oneSignalRect = oneSignalBellLauncher.getBoundingClientRect();
                if (listingControlBar.top < oneSignalRect.bottom) {
                    oneSignalBellLauncher.style.bottom = '20px';
                }
            }


        }
        else {
            setTimeout(() => checkForOneSignal(), 500);
        }
    }, [scrollY, initialized]);

    return <></>;
};

const toggleOneSignal = (show) => {
    let oneSignalBellLauncher = document.getElementById('onesignal-bell-launcher');
    if (oneSignalBellLauncher) {
        oneSignalBellLauncher.style.display = (show ? 'block' : 'none');
    }
}

export default OneSignalButton;
export { toggleOneSignal };